import actionCreator from 'utils/actionCreator';

/**
 * Action Types
 */
export const actionTypes = {
    REMOVE: '@app/loaders/REMOVE',
    RESET: '@app/loaders/RESET'
};

/**
 * Init state
 */
export const initState = {};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const loadersReducer = (state = initState, { type, payload }) => {
    /*
     * Reset state
     */
    if (type === actionTypes.RESET) {
        return initState;
    }

    /*
     * Remove single action
     */
    if (type === actionTypes.REMOVE) {
        const { [type]: value, ...removedState } = state;
        return removedState;
    }

    const isSuccess = type.includes('SUCCESS');
    const isRequest = type.includes('REQUEST');
    const isFailure = type.includes('FAILURE');

    if (isRequest) {
        return { ...state, [type]: true };
    }

    if (isSuccess || isFailure || !isRequest) {
        return { ...state, [type.replace(/SUCCESS|FAILURE/, 'REQUEST')]: false };
    }

    return state;
}
export default loadersReducer;

/**
 * Redux actions
 */
export const loadersActions = {
    remove: actionCreator(actionTypes.REMOVE),
    reset: actionCreator(actionTypes.RESET)
};
